import React, { useEffect } from "react";

import { generateInvoice } from "@megaronsa/ksef-fe-invoice-converter";

import { FullScreenPdfView } from "./FullScreenPdfView";
import { PdfViewer } from "./PdfViewer";

type Props = {
  ksefNumber: string;
  xml: Uint8Array;
  loading: boolean;
  error: string | null;
  showPreviewFunction: () => void;
  fillContainer?: boolean;
};

export const KsefInvoiceView: React.FunctionComponent<Props> = (props) => {
  const [pdf, setPdf] = React.useState<Uint8Array | null>(null);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    if (props.loading) return;
    xmlToPdf(props.xml, props.ksefNumber)
      .then(setPdf)
      .then(() => setLoading(false));
  }, [props.xml, props.ksefNumber, props.loading]);

  if (props.fillContainer) {
    return (
      <FullScreenPdfView
        file={pdf}
        loading={loading}
        error={props.error}
        onClose={props.showPreviewFunction}
      />
    );
  }

  return <PdfViewer file={pdf} showPreviewFunction={props.showPreviewFunction} error={props.error} loading={loading} />;
};

const xmlToPdf = async (xml: Uint8Array, ksefNumber: string) => {
  const ab = new ArrayBuffer(xml.byteLength);
  new Uint8Array(ab).set(xml);
  const file = new File([ab], "invoice.xml", { type: "text/xml" });
  const pdfBlob = await generateInvoice(file, { nrKSeF: ksefNumber }, "blob");
  const uint8Array = new Uint8Array(await pdfBlob.arrayBuffer());
  return uint8Array;
};
